<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['wxPush'],
      }"
      @click="configMainShow['wxPush'] = !configMainShow['wxPush']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>微信推送</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('wxPush', '微信推送')"
        >
          <el-switch v-model="configure.wxPush.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['wxPush'].timeRemaining)
          ? shoWDialogBuy(
              featureList['wxPush']['productKey'],
              '微信推送',
              'wxPush'
            )
          : featureList['wxPush'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.wxPush.enable
          ? ''
          : toggleEnable('wxPush', '微信推送')
      "
      :class="{
        'no-buy': isNaN(featureList['wxPush'].timeRemaining),
        expired: featureList['wxPush'].timeRemaining <= 0,
        'shut-off': !configure.wxPush.enable,
      }"
    >
      <el-row>
        <el-col :span="5">礼物事件</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.giftTks.giftBoxNoticeEnable"
            ></el-switch
            >金额≥
            <el-input-number
              v-model="configure.giftTks.giftBoxNoticePrice"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
              :precision="1"
            ></el-input-number>
            元抽出的礼物
            <!-- 元的
            <el-select
              v-model="configure.wxPush.newGiftPriceEligiblePrizes"
              slot="prepend"
              placeholder="选择礼物类型"
              size="mini"
            >
              <el-option
                v-for="item in giftOfNumList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.wxPush.newGiftNumNoticeEnable"
            ></el-switch
            >数量满足以下条件的
            <el-select
              v-model="configure.wxPush.newGiftNumEligiblePrizes"
              slot="prepend"
              placeholder="选择礼物类型"
              size="mini"
            >
              <el-option
                v-for="item in giftOfNumList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="sentence-list" style="margin-top:10px">
              <ul v-if="configure.wxPush.newGiftNumNoticeList.length">
                <li
                  v-for="(item, index) in configure.wxPush.newGiftNumNoticeList"
                  :key="index"
                >
                  <div class="text-col2-editor no-tag">
                    <div class="input-wrap">
                      <el-select v-model="item.giftName" placeholder="请选择">
                        <el-option-group
                          v-for="group in giftSelectOptions"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="(groupitem, index) in group.options"
                            :key="index"
                            :label="groupitem.label"
                            :value="groupitem.value"
                          ></el-option>
                        </el-option-group>
                      </el-select>
                      <input
                        type="number"
                        placeholder="数量..."
                        v-model="item.giftCount"
                      />
                    </div>
                  </div>
                  <i class="fa-window-close" @click="removeGiftNum(index)"></i>
                </li>
              </ul>
            </div>
            <div class="sentence-add">
              <div class="text-col2-editor no-tag">
                <div class="input-wrap">
                  <el-select v-model="giftName" placeholder="请选择">
                    <el-option-group
                      v-for="group in giftSelectOptions"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="(groupitem, index) in group.options"
                        :key="index"
                        :label="groupitem.label"
                        :value="groupitem.value"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                  <input
                    type="number"
                    placeholder="数量..."
                    v-model="giftNumber"
                  />
                </div>
                <el-button size="small" @click="addGiftNum">添加</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">身份事件</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.wxPush.nobleContinue.enable"
            ></el-switch
            >贵族续费≥
            <el-select
              v-model="configure.wxPush.nobleContinue.level"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in welcomeConfig"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.wxPush.nobleOpen.enable"></el-switch
            >贵族开通≥
            <el-select
              v-model="configure.wxPush.nobleOpen.level"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in welcomeConfig"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.wxPush.guardContinue.enable"
            ></el-switch
            >守护续费≥ V
            <el-input-number
              v-model="configure.wxPush.guardContinue.level"
              :controls-position="isPC ? 'right' : ''"
              :min="1"
              size="mini"
              :precision="0"
            ></el-input-number>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.wxPush.guardOpen.enable"></el-switch
            >守护开通≥ V
            <el-input-number
              v-model="configure.wxPush.guardOpen.level"
              :controls-position="isPC ? 'right' : ''"
              :min="1"
              size="mini"
              :precision="0"
            ></el-input-number>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.wxPush.highNobleOpen.enable"
            ></el-switch
            >任意房间-帝皇、超神帝皇开通
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">推送频率</el-col>
        <el-col :span="19">
          满
          <el-input-number
            v-model="configure.wxPush.messeageNum"
            :controls-position="isPC ? 'right' : ''"
            :min="1"
            :max="60"
            size="mini"
            :precision="0"
          ></el-input-number
          >条，或
          <el-input-number
            v-model="configure.wxPush.timeInterval"
            :controls-position="isPC ? 'right' : ''"
            :min="1"
            :max="60"
            size="mini"
            :precision="0"
          ></el-input-number
          >分钟，推送到微信
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('微信推送', 'wxPush')"
          >「微信推送」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      //欢迎设定配置项
      welcomeConfig: require("@/assets/js/welcomeConfig.json"),
      // 礼物名字
      giftName: "",
      // 礼物数量
      giftNumber: "",
      giftOfNumList: [
        { label: "所有礼物", value: "normal" },
        { label: "中奖礼物", value: "prize" },
        { label: "赠送礼物", value: "give" },
      ],
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          wxPush: true,
          global: true,
        };
      },
    },
    giftSelectOptions: {
      type: Array,
      default: require("@/assets/js/giftSelectOptions.json"),
    },
  },
  mounted() {},
  methods: {
    removeGiftNum(index) {
      this.configure.wxPush.newGiftNumNoticeList.splice(index, 1);
      this.configure.wxPush.newGiftNumNoticeList = this.configure.wxPush.newGiftNumNoticeList;
      this.$message.success("删除成功");
    }, // 推送礼物数量删除
    addGiftNum() {
      if (this.giftNumber <= 0) {
        this.$message.warning("数量不能为空哦");
        return;
      }
      if (this.giftName === "") {
        this.$message.warning("礼物不能为空哦");
        return;
      }
      let isNameRepeat = false;
      if (this.configure.wxPush.newGiftNumNoticeList.length) {
        this.configure.wxPush.newGiftNumNoticeList.forEach((val, index) => {
          if (val.giftName == this.giftName) {
            isNameRepeat = true;
          }
          if (this.configure.wxPush.newGiftNumNoticeList.length == index + 1) {
            if (!isNameRepeat) {
              this.configure.wxPush.newGiftNumNoticeList.unshift({
                giftName: this.giftName,
                giftCount: this.giftNumber,
              });
              this.giftName = "";
              this.giftNumber = "";
              this.giftTpl = [];
              this.$message.success("添加成功");
            } else {
              this.$message.warning("该礼物已添加");
            }
          }
        });
      } else {
        this.configure.wxPush.newGiftNumNoticeList = [];
        this.configure.wxPush.newGiftNumNoticeList.unshift({
          giftName: this.giftName,
          giftCount: this.giftNumber,
        });
        this.giftName = "";
        this.giftNumber = "";
        this.giftTpl = [];
        this.$message.success("添加成功");
      }
    }, //推送礼物数量添加
  },
};
</script>
